import { useMemo } from "react";
import { useRouter } from "next/router";

import { generateUrlArguments, timezone } from "@/utils";

import useForm from "@/hooks/useHookForm";
import useFormPayment from "@/hooks/useFormPayment";

import { useAppSelector } from "@/hooks/useRedux";

interface useBookYogaNutritionTrialFormProps {
  packData?: any;
  setFormError?: (error: string) => void;
}

const useBookYogaNutritionTrialForm = ({
  packData,
  setFormError = () => {},
}: useBookYogaNutritionTrialFormProps) => {
  const router = useRouter();

  const { countryCodeData } = useAppSelector((state) => state.dashboard);
  const { data } = useAppSelector((state) => state.bootCamp);

  const { title, nutritionGoalID, isTrialPack } = packData;

  let countryCodeDefault = useMemo(
    () => countryCodeData?.default?.code || "+91",
    [countryCodeData]
  );

  const defaultValues = useMemo(
    () => ({
      name: "",
      email: "",
      mobileCountryCode: countryCodeDefault,
      mobile: "",
      ...(nutritionGoalID ? { nutritionGoalID } : {}),
    }),
    [countryCodeDefault, nutritionGoalID]
  );

  const urlsArguments = generateUrlArguments();

  const { methods, resetData } = useForm({
    defaultValues,
  });

  const getSuccessPagePath = () => {
    if (data?.pageType === "YOGA" || data?.pageType === "GENERAL_YOGA") {
      //TODO: FIX THIS
      return "/plans/payments/yoga/success/";
    } else {
      return "/plans/payments/nutrition/success/";
    }
  };

  const onSuccessCallback = ({amount_paid, currency}) => {
    resetData();
    router.push({
      pathname: getSuccessPagePath(),
      query: {
        ...router?.query,
        boot_camp_name: title,
        // boot_camp_start_Date: startDate,
        // boot_camp_picture: thumbnail,
        boot_camp_type: data?.pageType,
        isTrialPack: isTrialPack,
        amount_paid,
        currency
      },
    });
  };

  const onFailureCallback = () => {
    resetData();
    router.push({
      pathname: "/payments/failure/",
      query: router?.query,
    });
  };

  const { isLoading, onBlur, onPackPurchase } = useFormPayment({
    methods,
    packData,
    urlsArguments,
    timezone,
    onSuccessCallback,
    onFailureCallback,
  });

  const { handleSubmit, getValues } = methods;

  const packPurchaseHandler = handleSubmit((formValues) => {
    setFormError("");

    const additionalData = { is_trial_sales: true };

    return onPackPurchase({
      ...formValues,
      ...additionalData,
    });
  });

  return {
    methods,
    isLoading,
    onBlur,
    packPurchaseHandler,
  };
};

export default useBookYogaNutritionTrialForm;
